import { render, staticRenderFns } from "./PainelConsultas.vue?vue&type=template&id=4b07c72e&"
import script from "./PainelConsultas.vue?vue&type=script&lang=js&"
export * from "./PainelConsultas.vue?vue&type=script&lang=js&"
import style0 from "./PainelConsultas.vue?vue&type=style&index=0&id=4b07c72e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports